<template>
  <div class="invoice-page">
    <div class="toolbar">
      <div class="left">已选择 {{ selectedRowKeys.length }} 条（可申请 {{ canApplyCount }} 条）</div>
      <div class="right">
        <a-button class="btn" type="primary" :disabled="selectedRowKeys.length === 0" @click="goApply">批量申请发票</a-button>
      </div>
    </div>

    <a-table
      :columns="columns"
      :data-source="rows"
      :loading="loading"
      :row-key="record => record.id"
      :pagination="pagination"
      :row-selection="rowSelection"
      @change="handleTableChange"
    >

      <template slot="status" slot-scope="text, record">
        <a v-if="record.invoiceStatus === '0' && record.jfmUrl" @click="openInvoiceUrl(record.jfmUrl)">{{ record.invoiceStatus_dictText}}</a>
        <span v-else>{{record.invoiceStatus_dictText}}</span>
      </template>
      <template slot="qdfphm" slot-scope="text, record">
        <a v-if="record.jfdz" @click="openInvoiceUrl(record.jfdz)">{{ record.qdfphm }}</a>
        <span v-else>{{ record.qdfphm || '-' }}</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-button type="link" @click="goDetail(record)" :disabled="!record.invoiceId">详情</a-button>
        <a-button type="link" v-if="record.status==='1' && (record.jfdz || record.jfmUrl)" @click="download(record)">下载</a-button>
      </template>
    </a-table>

    <!-- 发票弹出层 -->
    <a-modal
      :visible="invoiceModalVisible"
      :footer="null"
      :width="500"
      title="发票预览"
      @cancel="closeInvoiceModal"
    >
      <iframe
        :src="currentInvoiceUrl"
        style="width: 100%; height: 500px; border: none;"
        frameborder="0"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'StudentInvoiceList',
  data() {
    return {
      loading: false,
      rows: [],
      selectedRowKeys: [],
      invoiceModalVisible: false,
      currentInvoiceUrl: '',
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
      },
      columns: [
        { title: '缴费时间', dataIndex: 'orderTime', align: 'center', width: 120 },
        { title: '单据号', dataIndex: 'tradeNo', align: 'center', width: 130 },
        { title: '支付方式', dataIndex: 'tradeChannel', align: 'center', width: 100 },
        { title: '金额', dataIndex: 'amount', align: 'center', width: 80 },
        { title: '发票状态', dataIndex: 'invoiceStatus_dictText',scopedSlots: { customRender: 'status' }, align: 'center', width: 100 },
        { title: '开票时间', dataIndex: 'kprq', align: 'center', width: 120 },
        { title: '发票号码', dataIndex: 'qdfphm', align: 'center', scopedSlots: { customRender: 'qdfphm' } },
        { title: '操作', dataIndex: 'action', align: 'center', scopedSlots: { customRender: 'action' }, width: 120 }
      ],
    }
  },
  computed: {
    canApplyCount() {
      return this.rows.filter(item => !item.qdfphm && !item.invoiceStatus).length
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: !!record.qdfphm || !!record.invoiceStatus,
          },
        }),
      }
    },
  },
  created() {
    this.loadList()
  },
  methods: {
    onSelectChange(keys) {
      this.selectedRowKeys = keys
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadList()
    },
    loadList() {
      this.loading = true
      const params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
      this.axios
        .get('/stu/invoice/list', { params })
        .then((res) => {
          if (res.code !== 200) return
          const result = res.result || {}
          const records = result.records || []
          // 对学生的友好展示：1003(需认证)/1004(需登录) 统一显示为申请中
          records.forEach(item => {
            if (item.invoiceStatus === '1003' || item.invoiceStatus === '1004') {
              item.invoiceStatus = '0'
              item.invoiceStatus_dictText = '申请中'
            }
          })
          this.rows = records
          this.pagination.total = result.total || 0
          this.selectedRowKeys = this.selectedRowKeys.filter(key => this.rows.some(item => item.id === key && !item.qdfphm && !item.invoiceStatus))
        })
        .finally(() => {
          this.loading = false
        })
    },
    goApply() {
      const selectedOrders = this.rows
        .filter(item => this.selectedRowKeys.includes(item.id))
        .map(item => ({
          orderId: item.id,
          orderTime: item.orderTime,
          tradeNo: item.tradeNo,
          tradeChannel: item.tradeChannel,
          amount: item.amount,
          remark: item.remark,
        }))
      sessionStorage.setItem('invoice_apply_orders', JSON.stringify(selectedOrders))
      this.$router.push({
        path: '/personalcenters/invoice/apply',
        query: { orderIds: this.selectedRowKeys.join(',') },
      })
    },
    goDetail(record) {
      this.$router.push({
        path: '/personalcenters/invoice/detail',
        query: { id: record.invoiceId },
      })
    },
    download(record) {
      if (record.jfdz) {
        // 优先使用 jfdz，直接打开新窗口下载
        window.open(record.jfdz, '_blank')
      } else if (record.jfmUrl) {
        // 如果是 jfmUrl，使用弹出层显示
        this.showInvoiceModal(record.jfmUrl)
      } else {
        this.$message.warning('暂无可下载的发票文件')
      }
    },
    openInvoiceUrl(url) {
      window.open(url, '_blank')
    },
    showInvoiceModal(url) {
      this.currentInvoiceUrl = url
      this.invoiceModalVisible = true
    },
    closeInvoiceModal() {
      this.invoiceModalVisible = false
      this.currentInvoiceUrl = ''
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'

.btn {
  background: $bgColor !important;
  border: none;
}

.invoice-page
  background $bgcontent
  min-height 600px
  padding 20px

.toolbar
  display flex
  justify-content space-between
  align-items center
  margin-bottom 16px

// 发票状态超链接样式
.invoice-page >>> a
  color #1890ff
  cursor pointer
  transition all 0.3s

.invoice-page >>> a:hover
  color #40a9ff
  text-decoration underline
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/StudentInvoiceList.vue